import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import { SupplierRelationshipListNewParametersType } from "@sellar-io/api-v2/types";

export const useSupplierRelationshipCount = (
  params: SupplierRelationshipListNewParametersType,
  options?: ApiV2QueryOptions<number>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.SupplierRelationships,
      params,
    ],

    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `supplier-relationships/count`,
        params,
      }).then((data) => apiV2AssertResponse<number>(data).data),

    ...getDefaultQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: options,
    }),
  });
};
